import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { images } from "../../constants";

const HallOfFame = () => {
  const [hallOfFame, setHallOfFame] = useState([]);

  useEffect(() => {
    const fetchHallOfFame = async () => {
      try {
        const response = await fetch(
          "https://ofc-newsletter.onrender.com/api/names",
          {
            headers: {
              Accept: "application/json",
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          console.log("Got data:", data);
          setHallOfFame(data);
        } else {
          console.error("Failed to fetch names");
        }
      } catch (error) {
        console.error("Error fetching names:", error);
      }
    };

    fetchHallOfFame();
  }, []);

  return (
    <div className="app__home-body-right">
      <motion.div
        whileInView={{ x: [100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__home-body-right-text"
      >
        <h1>Hall of Fame</h1>
        <p>
          Subscribe to our newsletter before release to see your name on the
          hall of fame!
        </p>
        <br />
        <div className="app__home-body-right-text-table">
          {hallOfFame.map((value, index) => (
            <p key={index}>{value}</p>
          ))}
        </div>
      </motion.div>
      <div className="app__home-body-right-img">
        <div id="left-right-img">
          <img src={images.loginPortrait} alt="app-pages" />
        </div>
      </div>
    </div>
  );
};

export default HallOfFame;
